module.exports = __webpack_public_path__ + "img/LINEBET.1acba459.svg";